import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	commitIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	branchIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pullRequestIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reviewCount: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reviewIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	commitIconLabel: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.development.commit-icon-label',
		defaultMessage: 'Commits',
		description: 'Commit icon label',
	},
	branchIconLabel: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.development.branch-icon-label',
		defaultMessage: 'Branches',
		description: 'Branch icon label',
	},
	pullRequestIconLabel: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.development.pull-request-icon-label',
		defaultMessage: 'Pull requests',
		description: 'Pull request icon label',
	},
	reviewCount: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.development.review-count',
		defaultMessage: '{reviewCount} {reviewCount, plural, one {review} other {reviews}}',
		description: 'Represents the number of Crucible review linked to an issue',
	},
	reviewIconLabel: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.development.review-icon-label',
		defaultMessage: 'Reviews',
		description: 'Review icon label',
	},
});
export default messages;
